import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "loadSelect" ]

    change(event) {
        if (event.target.dataset.action === "click->hw-combobox#selectOnClick") {
            let frame = document.getElementById('new_load');
            let name = event.target.dataset.value
            frame.src = `/build_wizard/loads/new?name=${name}&format=turbo_stream`
            frame.reload();
        }
    }
}